export const CARD_OPTIONS = [
  "Open in Wallet",
  "Copy Link",
  "Send via Email",
  "Send as Check",
  "Send as ACH",
];

